import React, { Component } from 'react';
import { BeatLoader } from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import moment from 'moment';
import { _addNotification, _addNotificationError } from '../../../server/util';
import { get, postWithHeaders } from "../../../server/actions";

class NotSubmittedNotification extends Component {

       constructor(props){
        super(props)
            this.state={
            loading:false,
            notSubStuData:{
            runOn:{sun:false,mon:false,tue:false,wed:false,thu:false,fri:false,sat:false},
            paused:false,
            at:{hrs:'',mins:'00',am_pm:'AM'},
            Message:"As of <DATE>, the Household Application for <NAME> (Grade <GRADE>) has not been submitted. Please complete and submit the application as soon as possible to ensure that <NAME> is considered for meal eligibility benefits.<br/> This is an automated notification regarding the Household Application submission status.",
            lastRanOn:''
        }
     }
   this.onSubmit=this.onSubmit.bind(this)
}

componentDidMount(){
      this._notificationSystem=this.refs.notificationSystem

     get('/getfrmappnotsubmittedsettings/'+sessionStorage.getItem('SchoolId')+'?access_token=')
    .then(response=>{
        if(!response.ok){
        throw Error(response.statusText)
        }
        return response.json()
        }).then(data=>{
                  let runDays={sun:false,mon:false,tue:false,wed:false,thu:false,fri:false,sat:false}

                    if(data.runsOn){
                    data.runsOn.forEach(day=>{
                    runDays[day.toLowerCase()]=true
                })
            }
        this.setState({
                        notSubStuData:{
                        runOn:runDays,
                        paused:data.paused,
                        at:{
                            hrs:data.runTime.hh || '',
                            mins:data.runTime.mm || '',
                            am_pm:data.runTime.meridiem || 'AM'
                           },
                        Message:data.messageBody || this.state.notSubStuData.Message,
                        lastRanOn:data.lastRunOn
                 }
            })
         })
        .catch(error=>{
        console.log("Notification settings error",error)
        })
   }

hrs12Options=()=>{
        let options=[{text:'Select',value:''}]
        for(let i=1;i<=12;i++){
        let val=i<10?'0'+i:i.toString()
        options.push({text:val,value:val})
         }
     return options
    }

minsOptions=()=>{
        let options=[{text:'Select',value:''}]
        for(let i=0;i<=59;i++){
        let val=i<10?'0'+i:i.toString()
        options.push({text:val,value:val})
        }
     return options
  }

handleDayChange=(day,value)=>{
    let obj={...this.state.notSubStuData}
    obj.runOn[day]=value
    this.setState({notSubStuData:obj})
}

onSubmit(){
     let notSubStuObj=this.state.notSubStuData
     let selectedDays=[]

    Object.keys(notSubStuObj.runOn).forEach(day=>{
                        if(notSubStuObj.runOn[day]){
                        selectedDays.push(day)
                        }
      })
            if(selectedDays.length===0){
                _addNotificationError('Atleast one day in a week required.',this)
                return
                }
            if(notSubStuObj.at.hrs===''){
                _addNotificationError('Please select time to run the notification.',this)
                return
                }
            let data=JSON.stringify({
            paused:notSubStuObj.paused,
            runsOn:selectedDays,
            runTime:{
            hh:notSubStuObj.at.hrs,
            mm:notSubStuObj.at.mins,
            meridiem:notSubStuObj.at.am_pm
            },
            messageBody:notSubStuObj.Message
        })
    let headers={'Content-Type':'application/json'}
    postWithHeaders('/frmappnotsubmittedsettings/'+sessionStorage.getItem('SchoolId')+'?access_token=',data,headers)
    .then(response=>{
        if(!response.ok){
        throw Error(response.statusText)
        }
        return response.json()
        }).then(()=>{
        _addNotification("Notification settings saved.",this)
        })
        .catch(error=>{
        console.log("Save error",error)
        })
 }

 render(){
     let data=this.state.notSubStuData
    return(  
          <div>
            <NotificationSystem ref="notificationSystem"/>
            <section className="full-width clearfix margin-top">
            <div className='sweet-loading'
            style={{position:'fixed',top:'50%',left:'48%',zIndex:'1000'}}>
            <BeatLoader size={20} color={'#ea7066'} loading={this.state.loading}/>
            </div>

            <div className="container">
              <div className="row">
                 <div className="col-md-8 col-sm-12 col-xs-12 col-centered createmenu-panel">
                   <div className="panel panel-primary">
                     <div className="panel-heading text-center">
                         <h3 className="panel-title">NotSubmitted Students Notification</h3>
                     </div>

                     <div className="panel-body">
                    {/* Paused */}
                     <div className="row">
                        <div className="col-md-12">
                            <p style={{display:"inline-block",margin:"9px 25px"}}>Paused :</p>
                                <input
                                type="checkbox"
                                checked={data.paused}
                                onChange={(e)=>{
                                let obj={...data}
                                obj.paused=e.target.checked
                                this.setState({notSubStuData:obj})
                                }}
                                />
                        </div>
                    </div>
                    {/* Run On */}
                    <div className="row">
                      <div className="col-md-12">
                         <p style={{display:"inline-block",margin:"9px 25px"}}>Run On :</p>
                           {
                            Object.keys(data.runOn).map(day=>(
                               <label key={day} style={{marginRight:'10px', padding:"0 5px"}}>
                                    <input
                                    type="checkbox"
                                    checked={data.runOn[day]}
                                    onChange={(e)=>this.handleDayChange(day,e.target.checked)}
                                    />
                                    &nbsp;  {day.charAt(0).toUpperCase()+day.slice(1)}
                                </label>
                                ))
                            }
                        </div>
                    </div>
                    {/* Time */}
                    <div className="row">
                      <div className="col-md-12">
                        <p style={{display:"inline-block",margin:"9px 25px"}}>At :</p>
                            <select
                            value={data.at.hrs}
                            onChange={(e)=>{
                            let obj={...data}
                            obj.at.hrs=e.target.value
                            this.setState({notSubStuData:obj})
                            }}
                            >
                            {this.hrs12Options().map((item,i)=>(
                            <option key={i} value={item.value}>{item.text}</option>
                            ))}
                          </select>
                       <span style={{margin:"0 5px"}}>:</span>
                         <select disabled>
                                        <option >00</option>
                         </select> &nbsp;
                        <select
                        value={data.at.am_pm}
                        onChange={(e)=>{
                        let obj={...data}
                        obj.at.am_pm=e.target.value
                        this.setState({notSubStuData:obj})
                        }} >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                 {/* Message */}
                  <div className="row">
                    <div className="col-md-12">
                      <p style={{display:"inline-block",margin:"9px 25px"}}>Message :</p>
                       <textarea style={{width:"90%", marginLeft:"25px"}}
                            rows="6"
                            className="form-control"
                            value={data.Message}
                            onChange={(e)=>{
                            let obj={...data}
                            obj.Message=e.target.value
                            this.setState({notSubStuData:obj})
                            }} />
                       </div>
                   </div>
                   {/* Last Run */}
                   <div className="row">
                      <div className="col-md-12">
                        <span style={{display:"inline-block",margin:"9px 25px"}}>This emailer last ran on 
                         <b>
                            {
                            moment.utc(data.lastRanOn).local().format("MM/DD/YYYY LT")==='Invalid date'
                            ? ''
                            : moment.utc(data.lastRanOn).local().format("MM/DD/YYYY LT")
                            }
                         </b>
                       </span>
                     </div>
                  </div>
                  {/* Buttons */}
                  <div className="row">
                    <div className="col-md-12">
                        <button
                        className="btn btn-success pull-right"
                        onClick={this.onSubmit}
                        >Save</button>
                        <button
                        className="btn btn-danger pull-right"
                        style={{marginRight:'10px'}}
                        onClick={()=>window.history.back()}
                        >Cancel</button>
                    </div>
                 </div>
                </div>
              </div>
            </div>
         </div>
      </div>
    </section>
   </div>
  )
 }
}
export default NotSubmittedNotification


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/notSubmittedNotification/index.jsx